var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-loader-container"},[_c('div',{staticClass:"loader-icon-container"},[_c('img',{attrs:{"src":_vm.publicUrl + '/fasal-loader.gif',"width":"60px"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }